export default __webpack_public_path__ + "static/media/excel.858bd381.svg";